<template>
  <Modal
    :open="displayModal"
    title="Edit Video Details"
    size="large"
    modalIcon="fad fa-edit"
    modalIconColor="bg-blue-100 text-blue-700"
    :showEscapeButton="true"
    :showAcceptButton="true"
    :acceptButtonProgress="isProgressing"
    acceptButtonText="Save Video"
    @close="displayModal = false"
    @onSuccess="updateVideo"
    ref="modal"
  >
    <!-- -->
    <!-- {{ video.declined_message.message }}
            <br />
            Declined by {{ video.declined_message.reviewer.name }} at
            {{
              video.declined_message.created_at | displayLocalDateTime
            }}.<br /> -->

    <div class="rounded-md bg-yellow-50 p-4 mb-4">
      <div class="flex">
        <div class="ml-3 flex-1 md:flex md:justify-between">
          <p class="text-sm text-yellow-800 text-center">
            Currently, video editing is limited to title and description. More
            options will be coming soon.
          </p>
        </div>
      </div>
    </div>
    <div class="grid grid-cols-1 gap-4">
      <div>
        <label for="video_title" class="block text-sm font-medium text-gray-700"
          >Title</label
        >
        <input
          type="text"
          name="video_title"
          id="video_title"
          class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
          v-model="data.title"
        />
      </div>
      <div>
        <label
          for="video_description"
          class="block text-sm font-medium text-gray-700"
          >Narrative</label
        >
        <textarea
          id="video_description"
          name="video_description"
          rows="10"
          class="shadow-sm focus:ring-blue-500 focus:border-blue-500 mt-1 block w-full sm:text-sm border-gray-300 rounded-md"
          v-model="data.description"
        ></textarea>
      </div>
      <!-- <div>
        <label for="video_tags" class="block text-sm font-medium text-gray-700"
          >Tags</label
        >
        <input
          type="text"
          name="video_tags"
          id="video_tags"
          class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
          v-model="data.tags"
        />
      </div> -->
    </div>
  </Modal>
</template>

<script>
import * as Config from "@/config";

import Modal from "@/components/Modal";

export default {
  data() {
    return {
      displayModal: false,
      data: {},
      isProgressing: false
    };
  },

  components: {
    Modal
  },

  mounted() {
    this.$nextTick(
      function() {
        this.$eventBus.$on("stringer-edit-video-open-modal", this.open);
      }.bind(this)
    );
  },

  destroyed() {
    this.$eventBus.$off("stringer-edit-video-open-modal", this.open);
  },

  methods: {
    open(data) {
      console.log(data);
      this.displayModal = true;
      this.data = data;
    },

    saveVideoDetails(data) {
      console.log(data);
    },

    async updateVideo() {
      this.isProgressing = true;
      var data = {
        id: this.data.id,
        title: this.data.title,
        description: this.data.description
      };

      try {
        let res = await this.$http.post(
          Config.apiPath + "/api/v2/stringer/videos/edit/" + this.data.id,
          data
        );

        if (res.status !== 200) {
          this.isProgressing = false;
          return alert("Try again, there has been an error.");
        }

        this.isProgressing = false;
        this.$refs.modal.$emit("closeModalEvent");
      } catch (e) {
        this.isProgressing = false;
        return alert("Try again, there has been an error.");
      }
    }
  }
};
</script>
